<!--  -->
<template>
  <el-container class="container" id="container" v-title data-title="章节列表">
    <!-- <linglanHeader></linglanHeader> -->
    <el-main>
      <div class="main box flex">
        <div class="content-left" :style="leftWidth">
          <div class="flex title content-around justify-between">
            <div class="">{{ playTitle }}</div>
            <div class="btn">
              <el-button @click="toMycourses">返回课程列表</el-button>
            </div>
          </div>
          <div class="play" :style="playHeight">
            <div
              class="prism-player"
              :style="{ height: explainHeight }"
              id="player-con"
            ></div>
            <div v-if="isAudioPlay" class="audio-bg">
              <div>
                <div class="dot">
                  <img
                    class="tp"
                    :class="{ 'tp-active': !isPause }"
                    src="@/assets/images/panzi.png"
                  />
                  <div :class="{ 'pulse1-active': !isPause }" class="pulse1"></div>
                  <div :class="{ 'pulse2-active': !isPause }" class="pulse2"></div>
                </div>
                <img class="maobi" src="@/assets/images/maobi.png" />
              </div>
            </div>
            <overlay-scrollbars style="height: 110px">
              <div ref="explain" id="explain" class="explain">
                {{ courseDesc }}
              </div>
            </overlay-scrollbars>
          </div>
          <div class="tool">
            <div
              @click="shrink"
              class="shrink tool-item flex flex-column align-center justify-center"
            >
              <img src="@/assets/images/icon11.png" alt="" />
              {{ shrinkTitle }}
            </div>
            <div
              v-if="isOpen"
              :class="{ 'bg-red': tabCurrent == 0 }"
              class="flex tool-item flex-column align-center justify-center"
              @click="tabChange(0)"
            >
              <img src="@/assets/images/icon_06.png" alt="" />
              目录
            </div>
            <div
              v-if="isOpen && courseAudioList.length > 0"
              :class="{ 'bg-red': tabCurrent == 1 }"
              class="flex tool-item flex-column align-center justify-center"
              @click="tabChange(1)"
            >
              <img src="@/assets/images/icon_08.png" alt="" />
              音频
            </div>
            <div
              :class="{ 'bg-red': tabCurrent == 2 }"
              @click="tabChange(2)"
              v-if="isOpen"
              class="flex flex-column tool-item align-center justify-center"
            >
              <img src="@/assets/images/icon_10.png" alt="" />
              课件
            </div>
            <div style="position: relative; margin-top: 16px">
              <div
                class="drag flex align-center resize"
                v-bind:class="{ 'drag-hide': !isOpen }"
              >
                <div class="vertical"></div>
                <div class="vertical"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-loading="audioLoading"
          class="content-right overflow-hidden"
          :style="rightWidth"
        >
          <div v-if="isOpen" class="top">
            <p class="top-title text-ellipsis">{{ title }}</p>
            <p class="author flex align-center text-ellipsis">
              <img class="user" src="@/assets/images/user.png" alt="" />
              主讲师：{{ speaker }}
            </p>
          </div>
          <div class="horizontal-line mg-b0"></div>
          <!--3.（1）引用-->
          <overlay-scrollbars
            v-if="courseMaterialCateList.length > 1 && tabCurrent == 0"
            ref="osComponentRef"
            id="osComponentRef"
            :options="options"
          >
            <div class="course-tab">
              <div class="flex">
                <div
                  v-for="(item, index) in courseMaterialCateList"
                  :key="item.cateid"
                  @click="scrollClick(index, item)"
                  :class="{ 'text-white': tabIndex == index }"
                  :id="'scroll-item' + index"
                  class="flex-none scroll-item li"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </overlay-scrollbars>
          <!-- <item v-show="isOpen"></item> -->
          <div
            v-show="isOpen"
            class="position-relative"
            style="height: calc(100% - 60.7px); z-index: 11111"
          >
            <overlay-scrollbars
              v-show="tabCurrent == 0"
              :style="scrollHeight"
              ref="listScroll"
              id="listScroll"
              class="pt-1"
            >
              <div>
                <div v-for="(item, index) in courseList" :key="item.materialId">
                  <div v-if="item.cateId == cateidCur || cateidCur == -1" class="item1">
                    <div
                      @click="getContent(item, index)"
                      class="flex"
                      style="height: 50px"
                    >
                      <div class="text-ellipsis item-title flex-1">
                        <span>{{ item.chapterName }} {{ item.title }}</span>
                        <span v-if="item.isFinished == 1" class="over">已学完</span>
                      </div>
                      <div class="icon">
                        <i
                          :class="item.isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                        ></i>
                      </div>
                    </div>
                    <div class="horizontal-line"></div>
                    <!-- <transition name="plus-icon"> -->
                    <div v-if="item.isOpen">
                      <div v-for="(val, j) in item.list" :key="j" class="item2">
                        <div v-if="val.dataList">
                          <div
                            @click="openchapter(index, j)"
                            class="flex align-center pt-1 pb-1 pl-06"
                          >
                            <div class="circular flex-none">
                              <div
                                v-if="val.playProgress > 0"
                                class="circular-left"
                              ></div>
                              <div
                                v-if="val.playProgress >= 100"
                                class="circular-right"
                              ></div>
                            </div>
                            <div
                              class="flex text-ellipsis align-center w-100 font-smaller text-secondary ml-2"
                            >
                              <div class="flex text-ellipsis align-center flex-1">
                                <span class="text-ellipsis flex-1">{{
                                  val.chapterName
                                }}</span>
                                <div class="icon item2-icon">
                                  <i
                                    :class="
                                      val.isOpen
                                        ? 'el-icon-arrow-up'
                                        : 'el-icon-arrow-down'
                                    "
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="val.isOpen">
                            <div v-for="(data, k) in val.dataList" :key="k">
                              <div
                                @click="playItem(item, index, val, j, 1, data, k)"
                                :id="'play-item-data' + data.id"
                                :class="{ 'item-active': playId == data.id }"
                                class="text-secondary flex align-center pt-1 pb-1 pl-4"
                              >
                                <div class="circular flex-none">
                                  <div
                                    v-if="data.playProgress > 0"
                                    class="circular-left"
                                  ></div>
                                  <div
                                    v-if="data.playProgress >= 100"
                                    class="circular-right"
                                  ></div>
                                </div>
                                <div
                                  class="flex text-ellipsis align-center w-100 font-smaller ml-2"
                                >
                                  <div class="flex text-ellipsis align-center flex-1">
                                    <span class="text-ellipsis">{{ data.title }}</span>
                                    <img
                                      v-if="item.conType == 0 || item.conType == 8"
                                      src="@/assets/images/icon1_03.png"
                                      style="height: 15px; margin-left: 7px"
                                    />
                                    <img
                                      v-if="item.conType == 5 || item.conType == 6"
                                      src="@/assets/images/icon1_11.png"
                                      style="height: 15px; margin-left: 7px"
                                    />
                                    <img
                                      v-if="item.conType == 7 || item.conType == 3"
                                      src="@/assets/images/icon1_07.png"
                                      style="height: 15px; margin-left: 7px"
                                    />
                                  </div>
                                  <div
                                    v-if="item.conType != 0 || item.conType != 8"
                                    class="mr-3"
                                  >
                                    <span v-if="item.conType == 5 || item.conType == 6">{{
                                      data.duration
                                    }}</span>
                                    <span v-else>{{ data.durationS }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div
                            @click="playItem(item, index, val, j, 1)"
                            :class="{ 'item-active': playId == val.id }"
                            :id="'play-item-val' + val.id"
                            class="flex text-secondary align-center pt-1 pb-1 pl-06"
                          >
                            <div class="circular flex-none">
                              <div
                                v-if="val.playProgress > 0"
                                class="circular-left"
                              ></div>
                              <div
                                v-if="val.playProgress >= 100"
                                class="circular-right"
                              ></div>
                            </div>
                            <div
                              class="flex text-ellipsis align-center w-100 font-smaller ml-2"
                            >
                              <div class="flex text-ellipsis align-center flex-1">
                                <span class="text-ellipsis">{{ val.title }}</span>
                                <img
                                  v-if="item.conType == 0 || item.conType == 8"
                                  src="@/assets/images/icon1_03.png"
                                  style="height: 15px; margin-left: 7px"
                                />
                                <img
                                  v-if="item.conType == 5 || item.conType == 6"
                                  src="@/assets/images/icon1_11.png"
                                  style="height: 15px; margin-left: 7px"
                                />
                                <img
                                  v-if="item.conType == 7 || item.conType == 3"
                                  src="@/assets/images/icon1_07.png"
                                  style="height: 15px; margin-left: 7px"
                                />
                              </div>
                              <div
                                v-if="item.conType != 0 || item.conType != 8"
                                class="mr-3"
                              >
                                <span v-if="item.conType == 5 || item.conType == 6">{{
                                  val.duration
                                }}</span>
                                <span v-else>{{ val.durationS }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- </transition> -->
                  </div>
                </div>
              </div>
            </overlay-scrollbars>
            <overlay-scrollbars
              style="height: calc(100% - 40px)"
              ref="audioScroll"
              id="audioScroll"
              v-show="tabCurrent == 1"
              class="pt-1"
            >
              <div class="audio-item">
                <div
                  @click="audioClick(val, index)"
                  v-for="(val, index) in courseAudioList"
                  :key="index"
                  :id="'play-item-audio' + val.audioid"
                >
                  <div
                    :class="{ 'item-active': playId == val.audioid }"
                    class="flex text-secondary align-center pt-1 pb-1 pl-06"
                  >
                    <div class="circular flex-none">
                      <div v-if="val.playProgress > 0" class="circular-left"></div>
                      <div v-if="val.playProgress >= 100" class="circular-right"></div>
                    </div>
                    <div class="flex text-ellipsis align-center w-100 font-smaller ml-2">
                      <div class="flex text-ellipsis align-center flex-1">
                        <span class="text-ellipsis">{{ val.title }}</span>
                        <img
                          src="@/assets/images/icon1_11.png"
                          style="height: 15px; margin-left: 7px"
                        />
                      </div>
                      <div class="mr-3">
                        <span>{{ val.duration }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </overlay-scrollbars>
            <overlay-scrollbars
              style="height: calc(100% - 30px); background: #ffffff"
              ref="courseWareScroll"
              id="courseWarecroll"
              v-show="tabCurrent == 2"
              class="pt-1"
            >
              <div class="courseware">
                <div
                  v-if="courseWare.content"
                  @contextmenu.prevent
                  v-html="courseWare.content"
                ></div>
                <div v-else>
                  <img
                    src="@/assets/images/noCourseWare.jpg"
                    style="width: 312px !important; height: 314px !important"
                  />
                </div>
              </div>
            </overlay-scrollbars>
          </div>
        </div></div
    ></el-main>
    <!-- <el-footer height="100px"
      ><div class="footer-wraper">
        <div class="footer">
          <div class="img-wraper fl">
            <img src="@/assets/images/download.jpg" alt="" />
          </div>
          <div class="info fl">
            <p>
              本网站是为了在中医书友会微信公众号（灵兰中医App）购买视频课程的用户改善视听效果而开发
            </p>
            <b>咨询建议请扫描二维码添加客服企业微信</b>
          </div>
          <div class="copyright fr">
            © 2017 北京灵兰精诚中医科技有限公司版权所有<br />京ICP备15057334号
            <router-link tag="a" target="_blank" :to="{ name: 'privacyPolicy' }"
              ><span style="margin-left: 15px">隐私及个人信息保护政策</span></router-link
            >
            <br />
            <router-link tag="a" target="_blank" :to="{ name: 'permit' }"
              >出版物许可</router-link
            >
          </div>
          <div class="line fr"></div>
        </div></div
    ></el-footer> -->
  </el-container>
</template>

<script>
import $ from "jquery";
import linglanHeader from "@/components/header";
import item from "@/components/item";
import { dataUrl } from "@/config/deployUrl";
import AES from "@/libs/AES.js";
import { Message } from "element-ui";
export default {
  components: {
    linglanHeader,
    item,
  },
  computed: {
    appid() {
      return this.$store.state.appid;
    },
    scope() {
      return this.$store.state.scope;
    },
    redirectUri() {
      return this.$store.state.redirectUri;
    },
  },
  data() {
    return {
      courseList: null,
      playHeight: "height: calc(100% - 65.7px);",
      leftWidth: "width:74%",
      rightWidth: "width:26%",
      isOpen: true,
      shrinkTitle: "收缩",
      options: {},
      obj: null,
      tabIndex: 0,
      toolIndex: 0,
      courseId: null,
      courseMaterialCateList: [],
      speaker: null,
      title: null,
      playId: 0,
      playTitle: "",
      tabCurrent: 0,
      isAudioCurrent: false,
      courseAudioList: [],
      courseWareList: [],
      courseWare: {},
      player: null,
      playDataIndex: {
        i: 0,
        j: 0,
        k: 0,
      },
      articleIndexArr: [],
      isHistory: false,
      playHistoryList: [],
      playTime: 0,
      courseDesc: "",
      explainHeight: "height:100%",
      courseListCur: [],
      cateid: -1,
      isCate: false,
      cateidCur: -1,
      courseMaterialRecordId: "",
      palyPauseId: "",
      playStartTime: "",
      loadingTimer: null,
      audioLoading: false,
      scrollHeight: "height: calc(100% - 87px)",
      progress: 0,
      scrollTimer: null,
      isAudioPlay: false,
      isPause: true,
    };
  },
  methods: {
    setPlayProgress(progress, _i, _j, children, type) {
      let i = _i != undefined ? _i : this.playDataIndex.i;
      let j = _j != undefined ? _j : this.playDataIndex.j;
      let k = null;
      if (type == 0) {
        k = children;
      } else {
        k = children != undefined ? children : this.playDataIndex.k;
      }
      console.log("进度编辑");
      console.log(this.courseList[i].list[j].playProgress);
      this.courseList[i].list[j].playProgress =
        this.courseList[i].list[j].playProgress == 100 ? 100 : progress;
      this.progress = this.courseList[i].list[j].playProgress;
      this.courseAudioList.forEach((item) => {
        if (item.audioid == this.playId) {
          item.playProgress = item.playProgress == 100 ? 100 : progress;
          // this.progress = item.playProgress == 100 ? 100 : progress;
        }
      });
      if (k != undefined) {
        this.courseList[i].list[j].dataList[k].playProgress =
          this.courseList[i].list[j].dataList[k].playProgress == 100 ? 100 : progress;
        this.progress = this.courseList[i].list[j].dataList[k].playProgress;
        let _progress = 0;
        this.courseList[i].list[j].dataList.forEach((item) => {
          _progress += item.playProgress == undefined ? 0 : item.playProgress;
        });
        let progressTotal = 100 * this.courseList[i].list[j].dataList.length;
        console.log("是否学完");
        console.log(progressTotal);
        console.log(_progress);
        console.log(this.courseList[i].list);
        if (progressTotal > _progress) {
          this.courseList[i].list[j].playProgress = 1;
        } else {
          this.courseList[i].list[j].playProgress = 100;
        }
        console.log("播放完毕111111");
        console.log(this.courseList[i].list);
      } else {
        // console.log("总播放长度");
        // console.log(_total);
        // console.log(_totalProgress);
      }
      if (this.courseList[i].isFinished == 2) {
        let _totalProgress = 0;
        let _total = this.courseList[i].list.length * 100;
        this.courseList[i].list.forEach((item, index) => {
          _totalProgress += item.playProgress == null ? 0 : item.playProgress;
        });
        if (_total <= _totalProgress) {
          this.courseList[i].isFinished = 1;
        }
        console.log("播放1111111");
        console.log(this.courseList[i]);
        console.log(_totalProgress);
        console.log(_total);
      }
      this.$forceUpdate();
    },
    playItem(item, i, val, j, type, data, k) {
      console.log("播放type");
      console.log(type);
      if (this.playId != 0) {
        console.log(this.playId);
        console.log("第二次播放");
        this.playProgressForPC();
        if (this.courseMaterialRecordId && this.player) {
          let _currentTime = this.player.getCurrentTime();
          let _duration = this.player.getDuration();
          let _playProcess = Math.ceil(
            Math.round((_currentTime / _duration) * 10000) / 100.0
          );
          let _anchorData = {
            type: 3,
            id: this.courseMaterialRecordId,
            playProcess: _playProcess,
            playStartTime: this.playStartTime,
            duration: this.player.getCurrentTime(),
          };
          this.courseMaterialRecordForPC(_anchorData);
        }
      }
      this.isAudioCurrent = type == 1 ? false : true;
      if (type == 1 && this.cateidCur != -1) {
        this.isCate = true;
        this.cateid = this.cateidCur;
      } else {
        this.isCate = false;
        this.cateidCur = -1;
        this.cateid = -1;
      }
      if (item.conType == 0 || item.conType == 8) {
        let _playProgress = val.playProgress == 0 ? 1 : val.playProcess;
        if (!_playProgress) {
          _playProgress = 1;
        }
        console.log(_playProgress);
        // return;
        this.setPlayProgress(_playProgress, i, j, k, 0);
        let routeData = this.$router.resolve({
          path: "/article",
          query: {
            conId: AES.encrypt(val.id),
            courseId: AES.encrypt(item.courseId),
            conType: AES.encrypt(item.conType),
            materialId: AES.encrypt(item.materialId),
            albumId: AES.encrypt(item.albumId),
            playProgress: _playProgress,
          },
        });
        window.open(routeData.href, "_blank");
        return;
      }
      this.playDataIndex = {
        i: i,
        j: j,
        k: k,
      };
      let _i = i + 1;
      if (this.courseList.length != _i && this.courseList[_i].list.length == 0) {
        this.getUserCourseInfo4PC(
          this.courseList[_i].materialId,
          _i,
          this.courseList[_i].courseId,
          1,
          false
        );
      }
      // getUserCourseInfo4PC(materialId, i, courseId, type)
      if (data) {
        this.playId = data.id;
        this.playTitle = data.title;
        this.getVideoPlaySTS4PC(data);
        this.setPlayProgress(1, undefined, undefined, undefined);
      } else {
        this.playId = this.courseList[i].list[j].id;
        this.playTitle = this.courseList[i].list[j].title;
        this.getVideoPlaySTS4PC(this.courseList[i].list[j]);
        this.setPlayProgress(1, undefined, undefined, undefined);
        // this.courseList[i].list[j].playProgress = this.courseList[i].list[j].playProgress>=100?100:1
        // this.courseAudioList.forEach(item => {
        //     if(item.audioid == this.playId){
        //       item.playProgress = 100
        //     }
        // });
        // this.$forceUpdate();
      }
      this.getCourseWareById(item.conType);
      // this.$forceUpdate();
    },
    dragControllerDiv: function () {
      var resize = document.getElementsByClassName("resize");
      var left = document.getElementsByClassName("content-left");
      var mid = document.getElementsByClassName("content-right");
      var box = document.getElementsByClassName("box");
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          //颜色改变提醒
          //   resize[i].style.background = "#818181";
          var startX = e.clientX;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            resize[i].left = startX;
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
            if (moveLen < 450) moveLen = 450; // 左边区域的最小宽度为32px
            if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px
            resize[i].style.left = moveLen; // 设置左侧区域的宽度
            for (let j = 0; j < left.length; j++) {
              left[j].style.width = (moveLen / document.body.clientWidth) * 100 + "%";
              mid[j].style.width =
                ((box[i].clientWidth - moveLen) / document.body.clientWidth) * 100 + "%";
            }
          };
          // 鼠标松开事件
          document.onmouseup = function (evt) {
            //颜色恢复
            // resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    },
    shrink() {
      this.isOpen = this.isOpen ? false : true;
      if (this.isOpen) {
        //展开
        this.leftWidth = "width:74%;";
        this.rightWidth = "width:26%;";
        let me = this;
        me.dragControllerDiv();
        this.shrinkTitle = "收缩";
      } else {
        //收缩
        this.leftWidth = "width:100%;";
        this.rightWidth = "width:0%;";
        this.shrinkTitle = "展开";
      }
    },
    scrollClick(index, val) {
      // this.cateid = val.cateid;
      this.cateidCur = val.cateid;
      // this.courseList =  this.courseListCur.filter(item=> item.cateId == val.cateid)
      let _index = index;
      this.tabIndex = index;
      let instance = OverlayScrollbars(document.getElementById("osComponentRef"));
      //  instance.scroll($(".scroll-item:nth-child(10)"),500);
      // instance.scroll(document.getElementById("scroll-item"+_index),500,);
      instance.scroll(
        {
          el: document.getElementById("scroll-item" + _index),
          block: { x: "center" },
        },
        500
      );
    },
    //课程分类
    pcCourseMaterialCateList() {
      let token = localStorage.getItem("token");
      let reqdata = {
        token: token,
        courseId: this.courseId,
      };
      this.$request
        .post("/api/lectures/pcCourseMaterialCateList", reqdata)
        .then((res) => {
          let _list = [{ cateid: -1, name: "全部" }];
          this.courseMaterialCateList = _list.concat(res);
          this.getCourseContentsByCourseId();
          this.getAllAudioByCourseId4PC();
        })
        .catch((e) => {
          // console.log("错误")
          this.loading.close();
        });
    },
    //课程目录
    getCourseContentsByCourseId() {
      let token = localStorage.getItem("token");
      let reqdata = {
        token: token,
        courseId: this.courseId,
      };
      this.$request
        .post("/api/course/getCourseContentsByCourseId", reqdata)
        .then((res) => {
          // return;
          console.log("课程目录");
          console.log(res);
          this.courseDesc = res.courseDesc;
          if (this.courseDesc) {
            this.$nextTick(() => {
              // 页面渲染完成后的回调
              let height = this.$refs.explain.offsetHeight;
              if (height > 128) {
                height = 128;
              }
              this.explainHeight = "calc(100% - " + height + "px)";
            });
          }
          this.courseList = res.list;
          if (this.courseList.length == 0) {
            Message.error("当前课程没有内容");
            this.loading.close();
          }
          let courseIndex = 0;
          let _isHistory = false;
          this.courseList.forEach((value, index) => {
            value["list"] = [];
            value["isOpen"] = false;
            if (value.userCourseInfoVo) {
              courseIndex = index;
              _isHistory = true;
            }
          });
          let index = 0;
          for (let i = 0; i < this.courseList.length; i++) {
            if (this.courseList[i].conType == 0 || this.courseList[i].conType == 8) {
              this.articleIndexArr.push(i);
            }
          }
          if (_isHistory) {
            this.historyPlay(courseIndex);
            return;
          }
          for (let i = 0; i < this.courseList.length; i++) {
            if (this.courseList[i].conType != 0 && this.courseList[i].conType != 8) {
              index = i;
              break;
            }
          }
          // if (this.isHistory) {
          //   let playHistory = this.playHistoryList.filter(
          //     (item) => item.courseId == this.courseId
          //   );
          //   if (playHistory.length > 0) {
          //     index = playHistory[0].playDataIndex.i;
          //   }
          // }
          this.getUserCourseInfo4PC(
            this.courseList[index].materialId,
            index,
            this.courseList[index].courseId,
            0,
            true
          );
        });
    },
    historyPlay(i) {
      console.log("历史播放");
      console.log(i);
      console.log(this.courseList[i]);
      let res = this.courseList[i].userCourseInfoVo;
      let _list = [];
      if (res.courseArticle) {
        res.courseArticle.cateId = res.cateId;
        _list.push(res.courseArticle);
      }
      if (res.courseAudio) {
        res.courseAudio.cateId = res.cateId;
        _list.push(res.courseAudio);
      }
      if (res.courseVideo) {
        res.courseVideo.cateId = res.cateId;
        _list.push(res.courseVideo);
      }
      if (res.courseAudios) {
        let _arr = res.courseAudios;
        _arr.forEach((value, index) => {
          value["cateId"] = res.cateId;
        });
        _list = _list.concat(res.courseAudios);
      }
      if (res.courseVideos) {
        let _arr = res.courseVideos;
        _arr.forEach((value, index) => {
          value["cateId"] = res.cateId;
        });
        _list = _list.concat(res.courseVideos);
      }
      if (res.courseArticles) {
        let _arr = res.courseArticles;
        _arr.forEach((value, index) => {
          value["cateId"] = res.cateId;
        });
        _list = _list.concat(res.courseArticles);
      }
      if (res.chapterMap) {
        let _chapterMap = res.chapterMap;
        _chapterMap.forEach((value, index) => {
          value["isOpen"] = true;
          value["cateId"] = res.cateId;
        });
        _list = _list.concat(_chapterMap);
      }
      let _j = 0;
      let _k = 0;
      // this.courseList[i].cateId = res.cateId
      this.courseList[i].list = _list;
      this.courseList[i].isOpen = true;
      this.courseListCur = this.courseList;
      let _indexData = this.getHistoryPlayIndex(_list);
      // return
      _j = _indexData.j;
      _k = _indexData.k;
      this.isHistory = false;
      this.playId = _list[_j].id;
      this.playTitle = _list[_j].title;
      if (_list[_j].dataList) {
        this.playItem(this.courseList[i], i, _list, _j, 1, _list[_j].dataList[_k], _k);
      } else {
        this.playItem(this.courseList[i], i, _list, _j, 1);
      }
      // this.getVideoPlaySTS4PC(_list[0]);
      // this.getCourseWareById(this.courseList[i].conType);
      this.$forceUpdate();
    },
    getHistoryPlayIndex(list) {
      const _this = this;
      let _data = {
        j: 0,
        k: 0,
      };
      for (let j = 0; j < list.length; j++) {
        if (list[j].dataList) {
          for (let k = 0; k < list[j].dataList.length; k++) {
            if (list[j].dataList[k].playProgressEntity) {
              _this.playTime = list[j].dataList[k].playProgressEntity.duration;
              console.log("历史播放111");
              console.log(list[j].dataList[k].playProgressEntity.duration);
              _data.j = j;
              _data.k = k;
              return _data;
            }
          }
        } else {
          if (list[j].playProgressEntity) {
            _this.playTime = list[j].playProgressEntity.duration;
            console.log("历史播放111");
            console.log(list[j].playProgressEntity.duration);
            _data.j = j;
            _data.k = undefined;
            return _data;
          }
        }
      }
      return _data;
    },
    //查询详情
    getContent(val, i) {
      if (val.isOpen) {
        this.courseList[i].isOpen = false;
        this.$forceUpdate();
      } else {
        if (this.courseList[i].list.length > 0) {
          this.courseList[i].isOpen = true;
          this.$forceUpdate();
        } else {
          this.getUserCourseInfo4PC(val.materialId, i, val.courseId, 1, true);
        }
      }
    },
    getAllAudioByCourseId4PC() {
      //  const loading = this.$loading({
      //     lock: true,
      //     text: 'Loading',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      //   });
      // this.audioLoading = true;
      let token = localStorage.getItem("token");
      let reqdata = {
        token: token,
        courseId: this.courseId,
      };
      this.$request
        .post("/api/lectures/getAllAudioByCourseId4PC", reqdata)
        .then((res) => {
          console.log("音频列表");
          console.log(res.courseAudioList);
          this.courseAudioList = res.courseAudioList;
          //  loading.close();
          this.audioLoading = false;
        })
        .catch((e) => {
          console.log(e);
          // loading.close()
          this.audioLoading = false;
        });
    },
    openchapter(i, j) {
      this.courseList[i].list[j].isOpen = this.courseList[i].list[j].isOpen
        ? false
        : true;
      this.$forceUpdate();
    },
    getUserCourseInfo4PC(materialId, i, courseId, type, isOpen) {
      let token = localStorage.getItem("token");
      let reqdata = {
        token: token,
        materialId: materialId,
        courseId: courseId,
      };
      console.log(reqdata);
      this.$request.post("/api/course/getUserCourseInfo4PC", reqdata).then((res) => {
        console.log("课程详情");
        console.log(res);
        let _list = [];
        if (res.courseArticle) {
          res.courseArticle.cateId = res.cateId;
          _list.push(res.courseArticle);
        }
        if (res.courseAudio) {
          res.courseAudio.cateId = res.cateId;
          _list.push(res.courseAudio);
        }
        if (res.courseVideo) {
          res.courseVideo.cateId = res.cateId;
          _list.push(res.courseVideo);
        }
        if (res.courseAudios) {
          let _arr = res.courseAudios;
          _arr.forEach((value, index) => {
            value["cateId"] = res.cateId;
          });
          _list = _list.concat(res.courseAudios);
        }
        if (res.courseVideos) {
          let _arr = res.courseVideos;
          _arr.forEach((value, index) => {
            value["cateId"] = res.cateId;
          });
          _list = _list.concat(res.courseVideos);
        }
        if (res.courseArticles) {
          let _arr = res.courseArticles;
          _arr.forEach((value, index) => {
            value["cateId"] = res.cateId;
          });
          _list = _list.concat(res.courseArticles);
        }
        if (res.chapterMap) {
          let _chapterMap = res.chapterMap;
          _chapterMap.forEach((value, index) => {
            value["isOpen"] = true;
            value["cateId"] = res.cateId;
          });
          _list = _list.concat(_chapterMap);
        }
        let _j = 0;
        let _k = 0;
        // if (this.isHistory) {
        //   let playHistory = this.playHistoryList.filter(
        //     (item) => item.courseId == this.courseId
        //   );
        //   if (playHistory.length > 0) {
        //     _j = playHistory[0].playDataIndex.j;
        //     _k = playHistory[0].playDataIndex.k;
        //     this.playTime = playHistory[0].playTime;
        //   }
        // }
        // this.courseList[i].cateId = res.cateId
        if (_list.length == 0) {
          this.loading.close();
          return;
        }
        this.courseList[i].list = _list;
        this.courseList[i].isOpen = isOpen;
        this.courseListCur = this.courseList;
        if (this.isAudioCurrent) {
          for (let f = 0; f < this.courseList[i].list.length; f++) {
            if (
              (this.isCate && this.cateid == this.courseList[i].cateId) ||
              this.cateid == -1
            ) {
              if (this.courseList[i].list[f].dataList) {
                for (let g = 0; g < this.courseList[i].list[f].dataList.length; g++) {
                  if (this.courseList[i].list[f].dataList[g].id == this.audioid) {
                    _j = f;
                    _k = g;
                    break;
                  }
                }
              } else {
                if (this.courseList[i].list[f].id == this.audioid) {
                  _j = f;
                  break;
                }
              }
            }
          }
        }
        if (type == 0) {
          this.isHistory = false;
          // this.playId = _list[_j].id;
          this.playTitle = _list[_j].title;
          let _type = 1;
          if (this.isAudioCurrent) {
            _type = 0;
          }
          if (_list[_j].dataList) {
            this.playItem(
              this.courseList[i],
              i,
              _list,
              _j,
              _type,
              _list[_j].dataList[_k],
              _k
            );
          } else {
            this.playItem(this.courseList[i], i, _list, _j, _type);
          }
        }
        this.$forceUpdate();
        this.audioLoading = false;
        // this.courseList = res;
      });
    },
    getAudioIndex() {
      for (let f = 0; f < this.courseList[i].list.length; f++) {
        if (
          (this.isCate && this.cateid == this.courseList[i].cateId) ||
          this.cateid == -1
        ) {
          if (this.courseList[i].list[f].dataList) {
            for (let g = 0; g < this.courseList[i].list[f].dataList.length; g++) {
              if (this.courseList[i].list[f].dataList[g].id == this.audioid) {
                _j = f;
                _k = g;
                return;
              }
            }
          } else {
            if (this.courseList[i].list[f].id == this.audioid) {
              _j = f;
              return;
            }
          }
        }
      }
    },
    playScroll() {
      let i = this.playDataIndex.i;
      let j = this.playDataIndex.j;
      let k = this.playDataIndex.k;
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        if (k != undefined || k != null) {
          let listScroll = OverlayScrollbars(document.getElementById("listScroll"));
          listScroll.scroll(
            {
              el: document.getElementById(
                "play-item-data" + this.courseList[i].list[j].dataList[k].id
              ),
              block: { y: "begin" },
            },
            300
          );
          let audioScroll = OverlayScrollbars(document.getElementById("audioScroll"));
          audioScroll.scroll(
            {
              el: document.getElementById(
                "play-item-audio" + this.courseList[i].list[j].dataList[k].id
              ),
              block: { y: "begin" },
            },
            300
          );
        } else {
          let listScroll = OverlayScrollbars(document.getElementById("listScroll"));
          listScroll.scroll(
            {
              el: document.getElementById(
                "play-item-val" + this.courseList[i].list[j].id
              ),
              block: { y: "begin" },
            },
            300
          );
          let audioScroll = OverlayScrollbars(document.getElementById("audioScroll"));
          audioScroll.scroll(
            {
              el: document.getElementById(
                "play-item-val" + this.courseList[i].list[j].id
              ),
              block: { y: "begin" },
            },
            300
          );
        }
      }, 500);
    },
    getVideoPlaySTS4PC(val) {
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        this.loading.close();
      });
      this.playScroll();
      let _userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (val.videoid) {
        let reqdata = {
          videoId: val.id,
        };
        this.$request.post("/api/lectures/getVideoPlaySTS4PC", reqdata).then((res) => {
          let _anchorData = {
            type: 0,
            courseId: this.courseId,
            materialId: this.courseList[this.playDataIndex.i].materialId,
            conId: this.playId,
            dataSource: 3,
            conType: this.courseList[this.playDataIndex.i].conType,
            // macAddress: this.$store.state.deviceMac,
            userId: _userInfo.userId,
            alias: _userInfo.alias,
            albumId: this.courseList[this.playDataIndex.i].albumId,
          };
          this.courseMaterialRecordForPC(_anchorData);
          console.log("第一次播放");
          this.playProgressForPC(0);
          let _data = {
            vid: res.vid,
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            coverUrl: res.coverUrl,
            securityToken: res.securityToken,
            region: res.domainRegion,
          };
          this.aliPlayer(val, 1, _data);
        });
      } else {
        let _anchorData = {
          type: 0,
          courseId: this.courseId,
          materialId: this.courseList[this.playDataIndex.i].materialId,
          conId: this.playId,
          dataSource: 3,
          conType: this.courseList[this.playDataIndex.i].conType,
          // macAddress: this.$store.state.deviceMac,
          userId: _userInfo.userId,
          alias: _userInfo.alias,
          albumId: this.courseList[this.playDataIndex.i].albumId,
        };
        this.courseMaterialRecordForPC(_anchorData);
        this.playProgressForPC(0);
        this.aliPlayer(val, 0);
      }
    },
    getCourseWareById(conType) {
      let token = localStorage.getItem("token");
      let reqdata = {
        token: token,
        conId: this.playId,
        conType: conType,
      };
      // console.log("查询课件");
      // console.log(reqdata);
      this.$request.post("/api/course/getCourseWareById", reqdata).then((res) => {
        // console.log("查询课件1111");
        // console.log(res);
        if (res) {
          this.courseWareList.push(res);
          this.courseWare = res;
        } else {
          this.courseWare = {};
        }
      });
    },
    tabChange(index) {
      if (index == this.tabCurrent) return;
      this.tabCurrent = index;
      // if (this.tabCurrent == 1 && this.courseAudioList.length == 0) {
      //   this.getAllAudioByCourseId4PC();
      // }
      if (index == 0) {
        this.scrollHeight = "height: calc(100% - 87px)";
      } else {
        this.scrollHeight = "height: calc(100% - 40px)";
      }
      clearTimeout(this.scrollTimer);
      if (index == 0) {
        let i = this.playDataIndex.i;
        let j = this.playDataIndex.j;
        let k = this.playDataIndex.k;
        this.scrollTimer = setTimeout(() => {
          if (this.playDataIndex.k != undefined || this.playDataIndex.k != null) {
            let listScroll = OverlayScrollbars(document.getElementById("listScroll"));
            listScroll.scroll(
              {
                el: document.getElementById(
                  "play-item-data" + this.courseList[i].list[j].dataList[k].id
                ),
                block: { y: "begin" },
              },
              300
            );
          } else {
            let listScroll = OverlayScrollbars(document.getElementById("listScroll"));
            listScroll.scroll(
              {
                el: document.getElementById(
                  "play-item-val" + this.courseList[i].list[j].id
                ),
                block: { y: "begin" },
              },
              300
            );
          }
        }, 300);
      } else if (index == 1) {
        this.scrollTimer = setTimeout(() => {
          if (this.playDataIndex.k != undefined || this.playDataIndex.k != null) {
            let audioScroll = OverlayScrollbars(document.getElementById("audioScroll"));
            audioScroll.scroll(
              {
                el: document.getElementById(
                  "play-item-audio" + this.courseList[i].list[j].dataList[k].id
                ),
                block: { y: "begin" },
              },
              300
            );
          } else {
            let audioScroll = OverlayScrollbars(document.getElementById("audioScroll"));
            audioScroll.scroll(
              {
                el: document.getElementById(
                  "play-item-val" + this.courseList[i].list[j].id
                ),
                block: { y: "begin" },
              },
              300
            );
          }
        }, 300);
      }
      // if (index == 0) {
      //   this.isAudioCurrent = false;
      // } else if (index == 1) {
      //   this.isAudioCurrent = true;
      // }
    },
    courseMaterialRecordForPC(reqdata) {
      this.$request
        .post("/api/data/courseMaterialRecordForPC", reqdata, "", dataUrl)
        .then((res) => {
          if (reqdata.type != 3) {
            this.courseMaterialRecordId = res.id;
            this.palyPauseId = res.palyPauseId;
            this.playStartTime = res.playStartTime;
          }
        });
    },
    playProgressForPC(type) {
      console.log("type播放");
      console.log(type);
      let _userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let _currentTime = 0;
      let _duration = 0;
      let _playProcess = 0;
      if (this.player && type != 0) {
        console.log(this.player.getCurrentTime());
        _currentTime = this.player.getCurrentTime();
        _duration = this.player.getDuration();
        console.log(_currentTime);
        console.log(_duration);
        if (!_duration) return;
        _playProcess = Math.ceil(Math.round((_currentTime / _duration) * 10000) / 100.0);
      }
      _playProcess = this.progress >= 100 ? 100 : _playProcess;
      console.log("进度");
      console.log(this.progress);
      let reqdata = {
        courseId: this.courseId,
        materialId: this.courseList[this.playDataIndex.i].materialId,
        conId: this.playId,
        conType: this.courseList[this.playDataIndex.i].conType,
        // macAddress: this.$store.state.deviceMac,
        userId: _userInfo.userId,
        alias: _userInfo.alias,
        duration: _currentTime,
        playProcess: _playProcess,
        albumId: this.courseList[this.playDataIndex.i].albumId,
      };
      console.log("记录播放进度");
      console.log(reqdata);
      this.$request
        .post("/api/data/playProgressForPC", reqdata, "", dataUrl)
        .then((res) => {});
    },
    aliPlayer(val, type, data) {
      // console.log("阿里播放");
      // console.log(val);
      // console.log(type);
      // console.log(data);
      const _this = this;
      if (type == 0) {
        if (this.player) {
          this.player.off("ended", this.ended);
          this.player.off("play", this.playing);
          this.player.off("pause", this.pause);
          this.player.dispose();
        }
        this.isAudioPlay = true;
        this.player = new Aliplayer(
          {
            id: "player-con",
            source: val.aliUrl,
            width: "100%",
            height: "100%",
            autoplay: true,
            isLive: false,
            rePlay: false,
            playsinline: true,
            preload: true,
            controlBarVisibility: "hover",
            useH5Prism: true,
            skinLayout: [
              {
                name: "bigPlayButton",
                align: "blabs",
                x: 30,
                y: 80,
              },
              {
                name: "H5Loading",
                align: "cc",
              },
              {
                name: "errorDisplay",
                align: "tlabs",
                x: 0,
                y: 0,
              },
              {
                name: "infoDisplay",
              },
              {
                name: "tooltip",
                align: "blabs",
                x: 0,
                y: 56,
              },
              {
                name: "thumbnail",
              },
              {
                name: "controlBar",
                align: "blabs",
                x: 0,
                y: 0,
                children: [
                  {
                    name: "progress",
                    align: "blabs",
                    x: 0,
                    y: 44,
                  },
                  {
                    name: "playButton",
                    align: "tl",
                    x: 15,
                    y: 12,
                  },
                  {
                    name: "timeDisplay",
                    align: "tl",
                    x: 10,
                    y: 7,
                  },
                  {
                    name: "setting",
                    align: "tr",
                    x: 15,
                    y: 12,
                  },
                  {
                    name: "volume",
                    align: "tr",
                    x: 5,
                    y: 10,
                  },
                ],
              },
            ],
          },
          function (player) {
            // console.log(_this.playTime);
            if (_this.playTime > 0) {
              player.seek(_this.playTime);
            }
            player.play();
            _this.playTime = 0;
            player.on("ended", _this.ended);
            player.on("play", _this.playing);
            player.on("pause", _this.pause);
            $(document).unbind("keydown");
            $(document).bind("keydown", function (e) {
              console.log(e.keyCode);
              if (e.keyCode == 32) {
                if (_this.isPause) {
                  player.play();
                } else {
                  player.pause();
                }
              } else if (e.keyCode == 39) {
                //快进
                let _time = player.getCurrentTime() + 15;
                console.log(player);
                console.log(player.getCurrentTime());
                console.log(_time);
                _this.player.seek(_time);
              } else if (e.keyCode == 37) {
                //后退
                let _time = player.getCurrentTime() - 15;
                console.log(player);
                console.log(player.getCurrentTime());
                console.log(_time);
                player.seek(_time);
              }
            });
          }
        );
      } else {
        console.log("视频播放")
        this.isAudioPlay = false;
        if (this.player) {
          this.player.off("ended", this.ended);
          this.player.off("play", this.playing);
          this.player.off("pause", this.pause);
          this.player.dispose();
        }
        this.player = new Aliplayer(
          {
            id: "player-con",
            vid: data.vid,
            accessKeyId: data.accessKeyId,
            securityToken: data.securityToken,
            accessKeySecret: data.accessKeySecret,
            region: data.region,
            "format": "m3u8",
            "mediaType": "video",
            "encryptType": 1,
            "width": "100%",
            "height": "100%",
            "autoplay": true,
            "isLive": false,
            "rePlay": false,
            "playsinline": true,
            "preload": true,
            "controlBarVisibility": "hover",
            "useH5Prism": true
          },
          function (player) {
            // console.log(_this.playTime);
            if (_this.playTime > 0) {
              player.seek(_this.playTime);
            }
            player.play();
            _this.playTime = 0;
            player.on("ended", _this.ended);
            player.on("play", _this.playing);
            player.on("pause", _this.pause);
            $(document).unbind("keydown");
            $(document).bind("keydown", function (e) {
              console.log(e.keyCode);
              if (e.keyCode == 32) {
                if (_this.isPause) {
                  player.play();
                } else {
                  player.pause();
                }
              } else if (e.keyCode == 39) {
                //快进
                let _time = player.getCurrentTime() + 15;
                console.log(player);
                console.log(player.getCurrentTime());
                console.log(_time);
                _this.player.seek(_time);
              } else if (e.keyCode == 37) {
                //后退
                let _time = player.getCurrentTime() - 15;
                console.log(player);
                console.log(player.getCurrentTime());
                console.log(_time);
                player.seek(_time);
              }
            });
          }
        );
      }
    },
    pause() {
      console.log("暂停");
      // clearInterval(this.timer);
      const _this = this;
      _this.isPause = true;
      // let _data = {
      //   playDataIndex: _this.playDataIndex,
      //   playTime: _this.player.getCurrentTime(),
      //   courseId: _this.courseId,
      // };
      // let i = _this.playHistoryList.findIndex(
      //   (item) => item.courseId === _this.courseId
      // );
      // _this.playHistoryList.splice(i, 1);
      // _this.playHistoryList.push(_data);
      // localStorage.setItem(
      //   "playHistoryList",
      //   JSON.stringify(_this.playHistoryList)
      // );
      if (this.courseMaterialRecordId) {
        let _currentTime = _this.player.getCurrentTime();
        let _duration = _this.player.getDuration();
        let _playProcess = Math.ceil(
          Math.round((_currentTime / _duration) * 10000) / 100.0
        );
        let _anchorData = {
          type: 1,
          palyPauseId: _this.palyPauseId,
          id: _this.courseMaterialRecordId,
          playProcess: _playProcess,
          playStartTime: _this.playStartTime,
          duration: _this.player.getCurrentTime(),
        };
        _this.courseMaterialRecordForPC(_anchorData);
        _this.playProgressForPC();
      }
    },
    playing() {
      console.log("播放");
      // clearInterval(this.timer);
      const _this = this;
      _this.isPause = false;
      if (this.courseMaterialRecordId) {
        let _anchorData = {
          type: 2,
          id: _this.courseMaterialRecordId,
          playStartTime: _this.playStartTime,
        };
        _this.courseMaterialRecordForPC(_anchorData);
        console.log("第三次播放");
        _this.playProgressForPC();
      }
      // this.timer = setInterval(() => {
      //   let _data = {
      //     playDataIndex: _this.playDataIndex,
      //     playTime: _this.player.getCurrentTime(),
      //     courseId: _this.courseId,
      //   };
      //   let i = _this.playHistoryList.findIndex(
      //     (item) => item.courseId === _this.courseId
      //   );
      //   _this.playHistoryList.splice(i, 1);
      //   _this.playHistoryList.push(_data);
      //   localStorage.setItem(
      //     "playHistoryList",
      //     JSON.stringify(_this.playHistoryList)
      //   );
      // }, 5000);
    },
    ended() {
      const _this = this;
      let _currentTime = _this.player.getCurrentTime();
      let _duration = _this.player.getDuration();
      let _playProcess = Math.ceil(
        Math.round((_currentTime / _duration) * 10000) / 100.0
      );
      let _anchorData = {
        type: 3,
        id: _this.courseMaterialRecordId,
        playProcess: _playProcess,
        playStartTime: _this.playStartTime,
        duration: _this.player.getCurrentTime(),
        isOver: true,
      };
      _this.courseMaterialRecordForPC(_anchorData);
      _this.playProgressForPC();
      _this.courseMaterialRecordId = "";
      _this.palyPauseId = "";
      // clearInterval(this.timer);
      // let _data = {
      //   playDataIndex: _this.playDataIndex,
      //   playTime: 0,
      //   courseId: _this.courseId,
      // };
      // let i = _this.playHistoryList.findIndex(
      //   (item) => item.courseId === _this.courseId
      // );
      // _this.playHistoryList.splice(i, 1);
      // _this.playHistoryList.push(_data);
      // localStorage.setItem(
      //   "playHistoryList",
      //   JSON.stringify(_this.playHistoryList)
      // );
      this.setPlayProgress(
        100,
        this.playDataIndex.i,
        this.playDataIndex.j,
        this.playDataIndex.k
      );
      console.log("播放完毕");
      console.log(this.isAudioCurrent);
      if (this.isAudioCurrent) {
        let _audioCourseIndex = 0;
        if (this.courseAudioList.length >= this.audioCourseIndex + 1) {
          _audioCourseIndex = this.audioCourseIndex + 1;
        }
        this.audioClick(this.courseAudioList[_audioCourseIndex], _audioCourseIndex);
      } else {
        let i = this.playDataIndex.i;
        let j = this.playDataIndex.j;
        let k = this.playDataIndex.k;
        if (
          this.courseList[i].list[j].dataList &&
          this.courseList[i].list[j].dataList.length != k + 1
        ) {
          console.log("有第三级数据");
          //有第三级数据
          let _k = k + 1;
          this.playItem(
            this.courseList[i],
            i,
            this.courseList[i].list[j],
            j,
            1,
            this.courseList[i].list[j].dataList[_k],
            _k
          );
        } else {
          //无第三级数据
          console.log("无第三级数据");
          //判断是否有第二级
          let _j = j + 1;
          if (this.courseList[i].list.length != _j) {
            //有第二级
            console.log("有第二级");
            //判断新的第二级里是否有第三级
            if (this.courseList[i].list[_j].dataList) {
              //有
              this.playItem(
                this.courseList[i],
                i,
                this.courseList[i].list[_j],
                _j,
                1,
                this.courseList[i].list[_j].dataList[0],
                0
              );
            } else {
              console.log("没有");
              //没有
              this.playItem(this.courseList[i], i, this.courseList[i].list[_j], _j, 1);
            }
          } else {
            console.log("没有第二级");
            //没有第二级
            //  let index = this.articleIndexArr.indexOf(0);
            let nextIndex = i;
            // if((this.isCate && this.cateid == this.courseList[i].cateId) || this.cateid == -1){
            // for (let f = 0; f < this.articleIndexArr.length; f++) {
            //         if (
            //           nextIndex < this.articleIndexArr[f] &&
            //           this.articleIndexArr.indexOf(nextIndex) == -1
            //         ) {
            //           nextIndex = nextIndex + 1;
            //         }
            // }
            let newIndex = i + 1;
            for (let a = newIndex; a < this.courseList.length; a++) {
              if (
                this.courseList[a].conType != 0 &&
                this.courseList[a].conType != 8 &&
                (this.courseList[a].cateId == this.cateid || this.cateid == -1)
              ) {
                nextIndex = a;
                break;
              }
            }

            console.log(nextIndex);
            console.log(newIndex);
            console.log(this.playDataIndex.i);
            if (nextIndex == this.playDataIndex.i) {
              return;
            }
            // return
            this.courseList[nextIndex].isOpen = true;
            if (this.courseList[nextIndex].list.length > 0) {
              if (this.courseList[nextIndex].list[0].dataList) {
                //有
                this.playItem(
                  this.courseList[nextIndex],
                  nextIndex,
                  this.courseList[nextIndex].list[0],
                  0,
                  1,
                  this.courseList[nextIndex].list[0].dataList[0],
                  0
                );
              } else {
                //没有
                this.playItem(
                  this.courseList[nextIndex],
                  nextIndex,
                  this.courseList[i].list[0],
                  0,
                  1
                );
              }
            } else {
              this.audioLoading = true;
              this.getUserCourseInfo4PC(
                this.courseList[nextIndex].materialId,
                nextIndex,
                this.courseList[nextIndex].courseId,
                0,
                true
              );
            }
          }
        }
      }
      // this.courseList[this.playDataIndex.i].list[this.playDataIndex.j].playProgress = 100
      // this.courseAudioList.forEach(item => {
      //     if(item.audioid == this.playId){
      //       item.playProgress = 100
      //     }
      // });
      // this.$forceUpdate();
    },
    // courseMaterialRecordForPC(reqdata) {
    //   let token = localStorage.getItem("token");
    //   reqdata.token = token;
    //   this.$request
    //     .post("/api/data/courseMaterialRecordForPC", reqdata)
    //     .then((res) => {
    //       console.log(res);
    //     });
    // },
    audioClick(val, index) {
      this.isAudioCurrent = true;
      let i = this.courseList.findIndex((item) => item.materialId === val.materialId);
      this.audioid = val.audioid;
      this.audioCourseIndex = index;
      let _j = 0;
      let _k = 0;
      if (this.courseList[i].list.length == 0) {
        this.getUserCourseInfo4PC(
          this.courseList[i].materialId,
          i,
          this.courseList[i].courseId,
          0,
          true
        );
      } else {
        for (let f = 0; f < this.courseList[i].list.length; f++) {
          if (this.courseList[i].list[f].dataList) {
            for (let g = 0; g < this.courseList[i].list[f].dataList.length; g++) {
              if (this.courseList[i].list[f].dataList[g].id == this.audioid) {
                _j = f;
                _k = g;
                break;
              }
            }
          } else {
            if (this.courseList[i].list[f].id == this.audioid) {
              _j = f;
              break;
            }
          }
        }
        let _list = this.courseList[i].list;
        if (_list[_j].dataList) {
          this.playItem(
            this.courseList[i],
            i,
            _list[_j],
            _j,
            0,
            _list[_j].dataList[_k],
            _k
          );
        } else {
          this.playItem(this.courseList[i], i, _list[_j], _j, 0);
        }
      }
    },
    toMycourses() {
      this.$router.push("/mycourses");
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.loading = this.$loading({ fullscreen: true });
    // this.loadingTimer =  setTimeout(() => {
    //       loading.close();
    // }, 30000);
    this.playHistoryList = JSON.parse(localStorage.getItem("playHistoryList"));
    if (!this.playHistoryList) {
      this.playHistoryList = [];
      localStorage.setItem("playHistoryList", JSON.stringify([]));
      this.isHistory = false;
    } else {
      this.isHistory = true;
    }
    this.courseId = AES.decrypt(this.$route.query.courseId);
    this.title = AES.decrypt(this.$route.query.title);
    this.speaker = AES.decrypt(this.$route.query.speaker);
    document.onkeydown = function (ev) {
      var ev = window.event || ev;
      if (ev.ctrlKey && ev.keyCode == 67) {
        ev.returnValue = false;
        // alert("Ctrl+C被禁止啦！");
      } else if (ev.keyCode == 32) {
        return false;
      }
    };
    this.pcCourseMaterialCateList();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // $("#container").css({ "min-height": $(document).outerHeight() + "px" });
    // $(".footer-wraper").css({ display: "block" });
    let me = this;
    me.dragControllerDiv();
    let obj = this.$refs.osComponentRef;
    this.obj = obj;
    let that = this;
    this.options = {
      callbacks: {
        onScroll: function () {
          let positionY = obj.osInstance().scroll().position.y; //内容滚动的距离
          let maxY = obj.osInstance().scroll().max.y; //内容的高度
          console.log("1111111111111111111111111");
          if (positionY == maxY) {
            //滚动条滚动到底部
          }
        },
      },
    };
  },
  beforeDestroy() {
    const _this = this;
    _this.loading.close();
    let _currentTime = _this.player.getCurrentTime();
    let _duration = _this.player.getDuration();
    let _playProcess = Math.ceil(Math.round((_currentTime / _duration) * 10000) / 100.0);
    let _anchorData = {
      type: 3,
      id: _this.courseMaterialRecordId,
      playProcess: _playProcess,
      playStartTime: _this.playStartTime,
      duration: _this.player.getCurrentTime(),
    };
    _this.courseMaterialRecordForPC(_anchorData);
    _this.playProgressForPC();
    _this.player.off("ended", _this.ended);
    _this.player.off("play", _this.playing);
    _this.player.off("pause", _this.pause);
    _this.player.dispose();
    clearInterval(this.scrollTimer);
  },
};
</script>

<style scoped>
/* @import url(); 引入css类 */
@import url("../../assets/css/common.css");
@import url("../../assets/css/main.css");
@import url("../../assets/css/union.css");
@import url("../../assets/css/free.css");
.el-main {
  height: calc(100vh);
}
.el-header,
.el-main,
.el-footer {
  padding: 0px;
}
.main {
  height: 100%;
}
.content-left {
  width: 80%;
  position: relative;
  height: 100%;
}
.content-right {
  width: 20%;
  position: relative;
  background-color: #334075;
  height: 100%;
}
.title {
  background-color: #353f75;
  font-size: 18px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #ffffff;
  line-height: 28px;
  height: 65px;
  padding-left: 32px;
  line-height: 65px;
}
.el-button {
  color: #353f75;
  padding: 8px 10px;
}
.btn {
  padding-right: 57px;
}
/* .play{
    
} */
.drag {
  z-index: 1111;
  background: #353f75;
  border-radius: 10px;
  position: absolute;
  top: 55%;
  /* left: -30px; */
  right: -11px;
  width: 37px;
  height: 60px;
  padding-left: 8px;
  cursor: e-resize;
}
.drag .vertical {
  width: 2px;
  height: 38px;
  background: #dfe4ff;
}
.drag .vertical:last-child {
  margin-left: 6px;
}
.explain {
  /* background-color: #ffffff;
  height: 120px;
  padding: 30px 18px 42px 46px;
  color: #bbbbbb;
  font-size: 16px; */
  background-color: #ffffff;
  color: #bbbbbb;
  font-size: 16px;
  padding: 16px 18px 16px 46px;
  max-height: 120px;
  /* padding-left: 18px;
    padding-top: 6px; */
}
.content-right .top {
  height: 85px;
  background: linear-gradient(0deg, #353f75, #273167);
  color: #ffffff;
  padding-left: 30px;
}
.top-title {
  font-size: 18px;
  font-weight: normal;
  color: #eeeeee;
  line-height: 31px;
  padding-top: 14px;
}
.content-right .top .author {
  font-size: 12px;
  font-weight: normal;
  color: #ffffff;
  line-height: 31px;
}
.user {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.horizontal-line {
  width: 100%;
  height: 1px;
  opacity: 0.15;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.tool {
  z-index: 1111;
  position: absolute;
  /* left: -49px; */
  top: 21px;
  right: 0;
}
.tool .tool-item {
  width: 49px;
  height: 59px;
  background-color: #283268;
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  cursor: pointer;
}
.tool .tool-item:not(:first-child) {
  margin-top: 5px;
}
.shrink {
  color: #cccccc;
}
.drag-hide {
  display: none !important;
}
.course-tab {
  height: 50px;
  color: #bbbbbb;
  font-size: 16px;
}
.course-tab .li {
  padding: 12px 5px 8px 17px;
  cursor: pointer;
}
/deep/.os-theme-dark > .os-scrollbar > .os-scrollbar-track {
  background: #293575 !important;
}
/deep/.os-theme-dark > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle {
  background-color: #5d6cba !important;
}
/deep/ .os-theme-dark > .os-scrollbar-horizontal {
  height: 7px !important;
}
.container .main {
  padding-bottom: 0px !important;
}
.item1 {
  font-size: 14px;
  font-weight: normal;
  color: #dedee7;
  /* height: 50px; */
  padding-left: 21px;
  cursor: pointer;
  padding-right: 8px;
}
.item1 .item-title .over {
  color: #889bfa;
  font-size: 13px;
  border: 1px solid #8194fa;
  border-radius: 4px;
  padding: 4px;
  margin-left: 7px;
}
.item1 .item-title {
  padding: 16px 0 16px 0;
}
/* .item1> div{
    height: 50px;
} */
/deep/.icon {
  font-size: 20px;
  padding: 12px 10px 16px 0;
}
.horizontal-line {
  width: 100%;
  height: 1px;
  opacity: 0.15;
  background-color: #ffffff;
}
.circular {
  width: 14px;
  height: 14px;
  background: #1c1c28;
  border: 1px solid #8f8fa7;
  border-radius: 50%;
  position: relative;
}
.circular-left {
  position: absolute;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  /* line-height: 50px; */
  clip: rect(0px 6px 12px 0px);
  background-color: #e7a43a;
  top: 0.7px;
  left: 0.5px;
}
.circular-right {
  position: absolute;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  /* line-height: 50px; */
  background-color: #e7a43a;
  top: 0.7px;
  left: 0.5px;
}
.circular-whole {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: #e7a43a;
  margin-left: 0.6px;
  margin-top: 0.7px;
}
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.5s;
}
.plus-icon-leave-to {
  opacity: 0;
}
.item-active {
  background-color: #273268;
  color: #e7a43a;
}
.item2-icon {
  padding: 0 !important;
  padding-right: 10px !important;
}
.courseware {
  color: #494949 !important;
  padding-bottom: 10px;
}
.courseware,
.audio-item {
  padding-left: 21px;
  cursor: pointer;
  padding-right: 8px;
  color: #ffffff;
}
/deep/ .courseware div p span,
.courseware div h2 p span {
  color: #494949 !important;
}
.play {
  overflow: hidden;
  background-color: white;
}
/deep/ .courseware div p img,
.courseware div img {
  width: 100% !important;
}
/deep/ .courseware img {
  width: 100% !important;
}
.explain-height {
  height: calc(100% - 120px);
}
/* .container .main ul {
  width: auto;
  margin: 0 auto;
    padding: 0 14px;
} */
.audio-bg {
  position: absolute;
  width: 100%;
  z-index: 11;
  /* top: 19%; */
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.dot {
  position: absolute;
  right: 49%;
  margin-top: 30px;
  width: 30%;
  max-width: 400px;
}
.tp {
  width: 100%;
}
.tp-active {
  -webkit-transform: rotate (360deg);
  animation: rotation 10s linear infinite;
  -moz-animation: rotation 10s linear infinite;
  -webkit-animation: rotation 10s linear infinite;
  -o-animation: rotation 10s linear infinite;
}
.maobi {
  z-index: 11;
  position: relative;
  width: 40%;
  margin: auto;
  max-width: 500px;
}
/deep/ .prism-player {
  background-color: #ccc8c3 !important;
}
/deep/ .prism-player .prism-controlbar .prism-controlbar-bg {
  background: rgba(75, 75, 75, 0.8) !important;
}
.pulse1 {
  position: absolute;
  width: 100%;
  height: 100%;
  /* left: 120px;
  top: 120px; */
  border: 4px solid #002a8d;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  top: 0;
  /* right: -15px; */
}
.pulse1-active {
  -webkit-animation: circle-opacity 2s ease-out;
  -moz-animation: circle-opacity 2s ease-out;
  animation: circle-opacity 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.pulse2-active {
  -webkit-animation: warn1 2s ease-out;
  -moz-animation: warn1 2s ease-out;
  animation: warn1 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.pulse2 {
  position: absolute;
  width: 100%;
  height: 100%;
  /* left: 120px;
  top: 120px; */
  border: 4px solid #002a8d;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  top: 0;
  /* right: -15px; */
}
@keyframes warn1 {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }

  50% {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
@keyframes circle-opacity {
  from {
    opacity: 0.8;
    transform: scale(1.1);
  }
  to {
    opacity: 0;
    transform: scale(1.3);
  }
}
.mg-b0 {
  margin-bottom: 0 !important;
}
</style>
